import sendRejectManage from "../views/sendRejectManage";

export default [
  {
    path: "/sendRejectManage",
    name: "080수신거부",
    component: sendRejectManage,
  },
];
